import { ChannelData } from "lib/api/type";
import { atom } from "recoil";

export const channelState = atom<ChannelData[]>({
    key: "channel",
    default: [],
});
